import { Box, Typography, useTheme } from "@mui/material";
import { type FC, useEffect, useRef } from "react";
import { getScrollContainer } from "web_myplann/Shared/Utils/getScrollContainer";

type Props = {
	title: string;
	setStickyTitle?: React.Dispatch<React.SetStateAction<string>>;
	hideGroupedListLabel?: boolean;
};

export const GroupedListLabel: FC<Props> = ({
	title,
	setStickyTitle,
	hideGroupedListLabel,
}) => {
	const theme = useTheme();

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!setStickyTitle) return;
		if (!ref.current) return;
		const scrollEl = getScrollContainer(ref.current);

		const updateTitle = () => {
			if (!ref.current) return;
			const labelTop = ref.current.getBoundingClientRect().top;
			const scrollTop = scrollEl ? scrollEl.getBoundingClientRect().top : 0;
			const handoff = scrollTop + ref.current.offsetHeight;
			if (labelTop <= handoff) {
				setStickyTitle(title);
			}
		};

		updateTitle();

		const target: HTMLElement | Window = scrollEl ?? window;
		target.addEventListener("scroll", updateTitle, { passive: true });

		return () => {
			target.removeEventListener("scroll", updateTitle);
		};
	}, [setStickyTitle, title]);

	return (
		<Box
			ref={ref}
			padding="8px 16px"
			textAlign="left"
			display={hideGroupedListLabel ? "none" : "block"}
		>
			<Typography
				variant="deprecatedH3"
				color={theme.palette.deprecated.grey[700]}
			>
				{title}
			</Typography>
		</Box>
	);
};
